$(function () {
    'use strict';

    $('*[data-background-image]').each(function () {
        $(this).css({'background-image': 'url(' + $(this).data('background-image') + ')'})
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('#listing-detail-location a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var target = $(this).attr('href');
        if (target === '#street-view-panel') {
            var street_view = $('#listing-detail-street-view');
            new google.maps.StreetViewPanorama(document.getElementById('listing-detail-street-view'), {
                position: {
                    lat: street_view.data('latitude'),
                    lng: street_view.data('longitude')
                },
                pov: {heading: street_view.data('heading'), pitch: street_view.data('pitch')},
                zoom: street_view.data('zoom'),
                linksControl: !1,
                panControl: !1,
                visible: !0
            })
        }
    });

    $(".detail-banner-btn").click(function () {
        $(this).toggleClass("marked");
        var span = $(this).children("span");
        var toggleText = span.data("toggle");
        span.data("toggle", span.text());
        span.text(toggleText)
    });

    $("textarea").after('<div class="textarea-resize"></div>');

    showMoreLess();

    $(window).scroll(function () {
        if ($(this).scrollTop() >= 50) {
            $('#return-to-top').fadeIn(200)
        } else {
            $('#return-to-top').fadeOut(200);
        }
    });

    $('#return-to-top').click(function () {
        $('body,html').animate({scrollTop: 0}, 500);
    });

    $(document).on('click', '.listing-heart, .listing-heart-mobile', function () {
        let $el = $(event.target);

        favoriteRestaurant($el.data('restaurant'), $el.data('route'));
    });
});

$(window).bind('keydown', function (event) {
    if (event.ctrlKey || event.metaKey) {
        switch (String.fromCharCode(event.which).toLowerCase()) {
            case 's':
                event.preventDefault();
                var $focused = $(':focus');
                $focused.parent('form').trigger("click");
                break;
        }
    }
});

$('body').on('submit', '#searchform', function (e) {
    e.preventDefault();
    $(this).trigger('submitFrm')
});

$('body').on('click', '.searchByTag', function (e) {
    e.preventDefault();
    if ($(this).hasClass("checked")) {
        $(this).removeClass('checked')
    } else {
        $(this).addClass('checked')
    }
    $(this).trigger('submitFrm')
});

$('body').on('click', '.searchByCategory', function (e) {
    e.preventDefault();
    if ($(this).hasClass("checked")) {
        $(this).removeClass('checked')
    } else {
        $(this).addClass('checked')
    }
    $(this).trigger('submitFrm')
});

$('body').on('submitFrm', '.searchform', function (e) {
    var tags = [];
    var categories = [];
    var key = $(this).find("#key").val();
    var url = $(this).attr("action");
    $('.searchByTag.checked').each(function () {
        var tag_slug = $(this).data('tag_slug');
        tags.push(tag_slug)
    });
    $('.searchByCategory.checked').each(function () {
        var cat_slug = $(this).data('slug');
        categories.push(cat_slug)
    });
    $.post(url, {_method: "POST", tags: tags, key: key, categories: categories}, function (data) {
        window.location.href = data.url
    }, 'json');
});

$('body').on('blur', '.save-translation', function () {
    var url = $('table').data("url");
    var folder = $('table').data("folder");
    var file = $(this).data("file");
    var name = $(this).data("name");
    var value = $(this).val();
    var original_value = $(this).closest('tr').find('.original_value').text();
    if (original_value !== value) {
        $(this).closest('tr').find('.original_value').text(value);
        $.post(url, {_method: "POST", file: file, name: name, value: value, folder: folder}, function (data) {
            if (data.status == 'success') {
                $('.translation-notification').css({display: 'inline-block'});
                $('.' + name.replace(".", "-")).addClass('fa fa-check fa-2x');
                setTimeout(function () {
                    $('.' + name.replace(".", "-")).removeClass('fa fa-check fa-4x')
                }, 2000)
            } else {
                $('.translation-notification').css({display: 'inline-block'});
                $('.' + name.replace(".", "-")).addClass('fa fa-times fa-2x');
                $('.translation-notification').css({color: 'red'});
                setTimeout(function () {
                    $('.' + name.replace(".", "-")).removeClass('fa fa-times fa-4x')
                }, 2000)
            }
        })
    }
});

(function () {
    "use strict";
    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var canvas = this;
                setTimeout(function () {
                    var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]), len = binStr.length,
                        arr = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        arr[i] = binStr.charCodeAt(i)
                    }
                    callback(new Blob([arr], {type: type || 'image/png'}))
                })
            }
        })
    }
})();

function changeElementStatus(e) {
    var elementID = $(e).data('id');
    var elementBtn = $(e);
    var url = $(e).data("href");
    $.post(url, {}, function (data) {
        if (data.status == 'ok') {
            $(elementBtn).removeClass(data.rclass);
            $(elementBtn).addClass(data.aclass);
            $(elementBtn).html(data.newstatusbtn);
            $('div.status' + elementID).html(data.newstatus)
        } else {
            alert('error')
        }
    }, 'json')
}

function deleteElement(e) {
    var url = $(e).data('href');
    var deleteConfirm = $('table').data('delete-message');
    var refreshTable = $('table').attr('id');
    bootbox.confirm(deleteConfirm, function (result) {
        if (result == !0) {
            $.post(url, {_method: 'DELETE'}, function (data) {
                if (data.status == 'ok') {
                    $('#' + refreshTable).DataTable().ajax.reload()
                } else {
                    bootbox.alert(data.message)
                }
            })
        }
    })
}

function changeAccountRole(e) {
    var url = $(e).data('href');
    $.get(url, {}, function (data) {
        $('.showRoleModal').html(data);
        $('#viewRoleForm').modal('show')
    })
}

function commentReply(e) {
    var url = $(e).data('href');
    $.post(url, {}, function (data) {
        $('.showReplyModal').html(data);
        $('#viewReplyForm').modal('show')
    })
}

function updateAccountRole(e) {
    var formID = $('#updateUserRoleForm');
    var url = formID.attr('action');
    var formData = formID.serializeArray();
    var refreshTable = $('table').attr('id');
    $.post(url, {_method: 'PUT', formData}, function (data) {
        if (data.status == 'ok') {
            $('#viewRoleForm').modal('hide');
            $('#' + refreshTable).DataTable().ajax.reload()
        } else if (data.status == 'error') {
            $('.displayError').html('<div class="alert alert-danger">' + data.message + '</div>')
        } else {
            alert('error')
        }
    }, 'json').fail(function (data) {
    })
}

function syncTranslations(e) {
    var url = $(e).data('href');
    var refreshTable = $('table').attr('id');
    $('body').plainOverlay('show');
    $.post(url, {}, function (data) {
        bootbox.alert(data.message);
        $('#' + refreshTable).DataTable().ajax.reload();
        $('body').plainOverlay('hide')
    }, 'json')
}

function deleteBlogPicture(e) {
    var url = $(e).data('href');
    var deleteConfirm = $(e).data('delete-message');
    bootbox.confirm(deleteConfirm, function (result) {
        if (result == !0) {
            $.post(url, {_method: 'DELETE'}, function (data) {
                if (data.status == 'ok') {
                    $('.image_holder').html('<span class="fa-stack fa-lg"> <i class="fa fa-camera fa-stack-1x"></i> <i class="fa fa-ban fa-stack-2x text-danger"></i> </span>')
                } else {
                    bootbox.alert(data.message)
                }
            })
        }
    })
}

function getLatLongByDeviceOrIp(callback) {
    var allowDisallowLocate = !1;
    if (navigator.geolocation && location.protocol == 'https:') {
        navigator.geolocation.getCurrentPosition(function (position) {
            allowDisallowLocate = !0;
            callback([position.coords.latitude, position.coords.longitude])
        }, function () {
            allowDisallowLocate = !0;
            $.post('/ajax/get-lat-lng', {}, function (coordinates) {
                callback([coordinates[0], coordinates[1]])
            })
        }, {timeout: 2000});
        setTimeout(function () {
            if (!allowDisallowLocate) {
                $.post('/ajax/get-lat-lng', {}, function (coordinates) {
                    callback([coordinates[0], coordinates[1]])
                })
            }
        }, 3000)
    } else {
        $.post('/ajax/get-lat-lng', {}, function (coordinates) {
            callback([coordinates[0], coordinates[1]])
        })
    }
}

function ToggleMap() {
    var $content = $('#toggle_me');
    $content.fadeToggle("fast", function () {
        if ($content.hasClass('toggle_display')) {
            $content.toggleClass('toggle_display');
            if ($content.hasClass('init_map')) {
                initRestMap();
                $content.removeClass('init_map')
            }
        } else {
            $content.toggleClass('toggle_display')
        }
    })
}

function initInfobox() {
    $.ajax({url: '/assets/libraries/jquery-google-map/infobox.js', dataType: "script", success: initRestaurantMap})
}

function initRestaurantMap() {
    console.log('init');
    var listing_detail_map = $('#listing-detail-map');
    if (listing_detail_map.length) {
        var map = new google.maps.Map(document.getElementById('listing-detail-map'), {
            center: new google.maps.LatLng(listing_detail_map.data('latitude'), listing_detail_map.data('center-lng')),
            zoom: listing_detail_map.data('zoom'),
        });
        var myLatlng = new google.maps.LatLng(listing_detail_map.data('latitude'), listing_detail_map.data('longitude'));
        var marker = new google.maps.Marker({position: myLatlng, map: map})
    }
}

function remove_restaurant_button(id) {
    axios.post("/favorite/restaurant", {company_id: id}).then(function (response) {
        $("#restaurant-id-" + id).fadeOut();
        iziToast.success({title: response.message,})
    }).catch(function (error) {
        console.log(error)
    })
}

function showMoreLess() {
    let moreLessEl = $('#more-less');
    let showMoreWrapper = $('#show-more-wrapper');
    moreLessEl.text(moreLessEl.attr('data-more'));
    moreLessEl.on('click', function (e) {
        e.preventDefault();
        if (showMoreWrapper.hasClass('expanded')) {
            moreLessEl.text(moreLessEl.attr('data-more'))
        } else {
            moreLessEl.text(moreLessEl.attr('data-less'))
        }
        showMoreWrapper.toggleClass('expanded')
    })
}

function favoriteRestaurant(id, route) {
    axios.post(route, {model_id: id}).then(function (response) {
        if (response.data.status === 'ok') {
            if (response.data.voteType) {
                $("#favorite-" + id).removeClass('green');
                $("#favorite-map-" + id).removeClass('green');
                $("#favorite-mobile-" + id).removeClass('green');
            } else {
                $("#favorite-" + id).addClass('green');
                $("#favorite-map-" + id).addClass('green');
                $("#favorite-mobile-" + id).addClass('green');
            }
        }
        iziToast.show({title: response.data.message, color: response.data.status === "ok" ? 'green' : 'red'});
    }).catch(function (error) {
        console.log(error)
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts.js